import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../logging/logging.service';
import { LazyLoadEvent } from '../../models/DataTables/lazyLoadEvent';
import { ListingCategoryResponse, ListingGategoryGroupResponse } from '../../models/inModels/MarketPlaceModel';

@Injectable()
export class ListingCategoryService {
  private route = '/api/marketplace/categories'
  constructor(
    private http: HttpClient, 
    private auth: AuthenticationService, 
    private logging: LoggingService) { }

  
    getCategory(id: number): Promise<ListingCategoryResponse> {
      return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response as ListingCategoryResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    createCategory(item: ListingCategoryResponse): Promise<ListingCategoryResponse> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/create`, item, { headers: this.auth.header })
        .toPromise()
        .then(response => response as ListingCategoryResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    updateCategory(coupon: ListingCategoryResponse): Promise<ListingCategoryResponse> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/update`, coupon, { headers: this.auth.header })
        .toPromise()
        .then(response => response as ListingCategoryResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    deleteCategory(id: string): Promise<any> {
      return this.http.delete(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response)
        .catch(error => this.logging.handleError(error));
    }


    // Category Groups
    search(event: LazyLoadEvent): Promise<any> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/group/search`, event, { headers: this.auth.header })
        .toPromise()
        .then(response => response)
        .catch(error => this.logging.handleError(error));
    }

    get(id: number): Promise<ListingGategoryGroupResponse> {
      return this.http.get(`${this.auth.apiUrl}${this.route}/group/get/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response as ListingGategoryGroupResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    create(item: ListingGategoryGroupResponse): Promise<ListingGategoryGroupResponse> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/group/create`, item, { headers: this.auth.header })
        .toPromise()
        .then(response => response as ListingGategoryGroupResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    update(coupon: ListingGategoryGroupResponse): Promise<ListingGategoryGroupResponse> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/group/update`, coupon, { headers: this.auth.header })
        .toPromise()
        .then(response => response as ListingGategoryGroupResponse)
        .catch(error => this.logging.handleError(error));
    }
  
    delete(id: string): Promise<any> {
      return this.http.delete(`${this.auth.apiUrl}${this.route}/group/delete/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response)
        .catch(error => this.logging.handleError(error));
    }

}




// WEBPACK FOOTER //
// ./src/app/services/listing-categories/listing-category.service.ts